import { getAdapter } from '@cheerfy/lib/reactive/features/api/adapter';
import {
    LoyaltyAccountAdapter,
} from '@cheerfy/lib/reactive/features/api/models/loyalty/loyaltyAccount/loyaltyAccount.adapter';
import { LoyaltyAccountModel } from '@cheerfy/lib/reactive/features/api/models/loyalty/loyaltyAccount/loyaltyAccount.model';
import { Repository } from '../repository';

export class CustomerRepository extends Repository {
    public async getLoyaltyAccount(code: string, token: string): Promise<LoyaltyAccountModel> {
        const { data } = await this._rawBackendRequest.get(`/loyalty-account/${code}/`, {
            headers: {
                authorization: `Token ${token}`,
            },
        });

        return getAdapter(LoyaltyAccountAdapter).adapt(data);
    }
}
